import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';

@Component({
  selector: 'app-foo',
  standalone: true,
  imports: [
    CommonNgModule
  ],
  templateUrl: './foo.component.html',
  styleUrl: './foo.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FooComponent {
  @Input() Theme:any;
  constructor() { }

  ngOnInit() {
  }
}
